import { observer } from 'mobx-react';

import SteppedComponent from 'js/components/pages/SteppedComponent';
import analytics from 'js/services/Analytics';
import { lightGrey1Color } from 'js/config/style';
import { isPhoneNumber } from 'js/services/Regex';
import { url } from 'js/services/Network';

import TokenConfirmPageState from 'js/stores/pages/TokenConfirmPageState';

import PickupDetails from './PickupDetails';
import ShippingOptions from './ShippingOptions';
import ReviewOrder from './ReviewOrder';
import UserInfo from './UserInfo';

@observer
export default class TokenConfirmPage extends SteppedComponent {
  loginRequired = true;
  pageName = 'TokenConfirmPage';
  pageColor = lightGrey1Color;

  backNav = () => ({
    mode: 'back',
    text: this.page.purchase_token.title,
    url: url('status-page', this.page.purchase_token),
  });

  bootstrap = () => this.page.load();

  page = TokenConfirmPageState.create({
    alias: this.props.alias,
  }).setSteps(this, 'token-confirm-page', [
    {
      name: 'pickup-details',
      label: 'Pick-up details',
      component: PickupDetails,
      isComplete: (page, step) => page.address.hasAddress,
      skipWhen: (page, step) => step.isComplete(page, step),
      onEnter: (page, step) => { /*analytics.page('BC_viewed pickup details')*/ },
      showStepMenu: true,
    },
    {
      name: 'shipping',
      label: 'Shipping',
      component: ShippingOptions,
      isComplete: (page, step) => !!page.shipping_service,
      onEnter: (page, step) => { /*analytics.page('BC_viewed shipping method')*/ },
      showStepMenu: true,
    },
    {
      name: 'review',
      label: 'Review',
      component: ReviewOrder,
      isComplete: (page, step) => !!(page.address.hasAddress && page.shipping_service && page.credit_card.isFilledIn),
      onEnter: (page, step) => {
        // page.credit_card.setBillingAddress(page.address);
        //analytics.page('BC_reviewed order')
      },
      showStepMenu: true,
    },
    {
      name: 'info',
      label: 'Info',
      component: UserInfo,
      isComplete: (page, step) => !!(page.full_name.length && page.phone_number.match(isPhoneNumber)),
      skipWhen: (page, step) => step.isComplete(page, step),
      onEnter: (page, step) => { /*analytics.page('BC_viewed user info')*/ },
    },
  ]);
}
